import { render, staticRenderFns } from "./ContractIcon.vue?vue&type=template&id=2d993288&"
import script from "./ContractIcon.vue?vue&type=script&lang=js&"
export * from "./ContractIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports